import _ from 'underscore'
import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import Header from 'pages/UnassignedDevice/Header'
import Device from 'pages/Device/indexLegacy'
import NotFound from 'pages/NotFound'

import { useSessionContext } from 'hooks/SessionContext'
import useDeviceSearch from 'hooks/useDeviceSearch'

import { LoadingSinglePanePage, SinglePanePage } from 'styles/shared'

import { DeviceBase } from 'types/Device'

const UnassignedDevice = () => {
  const { session: { dealerId } } = useSessionContext()
  const { deviceId } = useParams()
  const { devices, areDevicesLoaded } = useDeviceSearch(useMemo(() => [deviceId], [deviceId]))

  if (!areDevicesLoaded) {
    return <LoadingSinglePanePage />
  }

  if (!devices || _.isEmpty(devices)) {
    return (
      <SinglePanePage>
        <NotFound />
      </SinglePanePage>
    )
  }

  const unassignedDevice : DeviceBase = devices[0]

  return (
    <SinglePanePage>
      <Header unassignedDevice={unassignedDevice} dealerId={dealerId} />
      <Device dealerId={dealerId} deviceId={unassignedDevice.deviceId} isActive isUnassignedDevice />

      <div>This device has not been assigned to a customer.</div>
    </SinglePanePage>
  )
}

export default UnassignedDevice
